




























import ChemicalLatex from '../../tasks/components/displayers/ChemicalLatex.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import i18n from '@/locales/composables/i18n';
import {computed, defineComponent, PropType} from '@vue/composition-api';

export default defineComponent({
  name: 'MathEquationInput',
  components: {ChemicalLatex, StembleLatex},
  props: {
    showNote: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    inputPlaceholder: {
      type: String as PropType<string>,
      default: () => i18n.t('mathEquationInput.placeholder'),
    },
    solo: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    flat: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    outlined: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    prependText: {
      type: String as PropType<string>,
      default: null,
    },
    appendText: {
      type: String as PropType<string>,
      default: null,
    },
    value: {
      type: String as PropType<string>,
      default: null,
    },
  },
  setup(props) {
    const notationValue = computed(() => props.value ?? '');

    return {
      notationValue,
    };
  },
});
